import type { z } from 'zod'
import type { apiZod } from '@/shared/api'

type RecordingDto = z.infer<typeof apiZod.zRecordingView>
type TrackDto = z.infer<typeof apiZod.zRecordingTrackView>
type CompositeDto = z.infer<typeof apiZod.zRecordingCompositeView>

function toTrack(dto: TrackDto) {
  return {
    participantId: dto.participant_id,
    identity: dto.identity,
    state: dto.state,
    url: dto.url,
    startedAt: dto.started_at,
    endedAt: dto.ended_at,
  }
}

function toComposite(dto: CompositeDto) {
  return {
    state: dto.state,
    url: dto.url,
    startedAt: dto.started_at,
    endedAt: dto.ended_at,
  }
}

export function toRecording(dto: RecordingDto) {
  return {
    meetingId: dto.meeting_id,
    state: dto.state,
    tracks: (dto.tracks ?? []).map(toTrack),
    composite: dto.composite ? toComposite(dto.composite) : undefined,
  }
}
